import { z } from "zod";

/** Mirrors the Prisma `KnowledgeKind` enum, in the order the client shows them. */
export const knowledgeKindSchema = z.enum([
  "PRODUCT",
  "PERSONAS",
  "VOICE",
  "COMPETITORS",
  "MARKET",
  "CHANNELS",
  "EXPERIMENT_PLAN",
  "DIRECTION",
]);
export type KnowledgeKind = z.infer<typeof knowledgeKindSchema>;

export const KNOWLEDGE_LABELS: Record<KnowledgeKind, { label: string; about: string }> = {
  PRODUCT: { label: "Product", about: "What it is, who it's for, how it works, what it costs" },
  PERSONAS: { label: "Audience", about: "Who you're talking to and what they worry about" },
  VOICE: { label: "Voice", about: "How the brand sounds: words to use and avoid" },
  COMPETITORS: { label: "Competitors", about: "Alternatives people compare you with" },
  MARKET: { label: "Market", about: "Timing, seasons and what's happening around you" },
  CHANNELS: { label: "Channels", about: "Where you post and the rules for each" },
  EXPERIMENT_PLAN: { label: "Experiments", about: "What you're testing and how you'll judge it" },
  DIRECTION: {
    label: "Standing direction",
    about: "Rules from your reviews that agents always follow",
  },
};

/** Knowledge is markdown; this keeps one document under about 100 pages. */
export const knowledgeBodySchema = z.string().max(200_000);

export const claimKindSchema = z.enum(["APPROVED", "BANNED"]);
export type ClaimKind = z.infer<typeof claimKindSchema>;

export const claimStatusSchema = z.enum(["ACTIVE", "WITHHELD", "RETIRED", "SUGGESTED"]);
export type ClaimStatus = z.infer<typeof claimStatusSchema>;

/** The short id agents cite, e.g. A4. */
export const claimCodeSchema = z
  .string()
  .trim()
  .toUpperCase()
  .regex(/^[A-Z]{1,3}\d{1,4}$/, { message: "Use a letter and a number, like A21" });
